import { Grid, Typography } from "@mui/material";
import React from 'react'

export function ChatBox(props) {
    const ref = useScrollDown();
    return <Grid container sx={{
        padding: "20px",
        overflow: "scroll"
    }}
        {...props} ref={ref}>
        {props.children}
    </Grid>;
}

function useScrollDown() {
    const ref = React.useRef();
    React.useEffect(() => {
        if (ref.current) {
            ref.current.scrollTop = ref.current.scrollHeight;
        }
    });
    return ref;
}

export function Message(props) {
    return <Grid item xs={12} sx={{
        marginBottom: "6px",
        height: "min-content",
    }} container justifyContent={props.side} >
        <Grid xs={8} item sx={{
            backgroundColor: "rgb(238, 242, 246)",
            borderRadius: "10px",
            padding: "10px",
            overflowWrap: "break-word"
        }}>
            <Typography variant="body1">
                {props.children}
            </Typography>
            <Typography variant="caption" sx={{
                width: "100%",
                display: "block",
                textAlign: "right"
            }}>
                {props.by}{props.time && ` - ${new Date(props.time).toLocaleString()}`}
            </Typography>
        </Grid>
    </Grid >
}